import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import VerProfSaude from '../../../../../components/auth/saude/profissionais/listar/prof'


function VerProfissionaisaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Visualizando Profissional da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
               <VerProfSaude />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default VerProfissionaisaudeScreen;